import React from 'react';
import CTAButton from './CTAButton';
const Sidebar = () => {
  const productImage = 'https://cdn.shopify.com/s/files/1/0855/3132/8839/files/3_frame_gif.webp?v=1739899184';
  const beforeAfterImage = 'https://cdn.shopify.com/s/files/1/0855/3132/8839/files/Screenshot__7_1.png?v=1739897401';
  const testimonialImage = 'https://cdn.shopify.com/s/files/1/0855/3132/8839/files/12_1.png?v=1739898981';
  return <div className="space-y-6" data-id="element-254">
      <div className="border border-[#804C5C]/20 rounded-lg p-4 bg-white shadow-lg" data-id="element-255">
        <h3 className="text-2XL font-bold text-center mb-4 text-[#804C5C]" data-id="element-256">
          Glowly Hajstimulátor
        </h3>
        <img src={productImage} alt="Glowly hajápoló eszköz" className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" data-id="element-257" />
        <div className="text-center mb-4" data-id="element-258">
          <span className="text-2xl font-bold text-[#804C5C]" data-id="element-259">21.990 Ft</span>
          <span className="text-gray-500 line-through ml-2" data-id="element-260">38.900 Ft</span>
        </div>
        <p className="text-sm text-gray-600 mb-4 text-center" data-id="element-261">
          Otthoni hajhullás elleni kezelés - klinikai hatékonyság
        </p>
        <CTAButton data-id="element-262" />
      </div>
  
    </div>;
};
export default Sidebar;